// extracted by mini-css-extract-plugin
export var checkbox = "_6m-0";
export var circle = "_6m-3";
export var horizontalContainer = "_6m-7";
export var sm = "_6m-5";
export var switch0 = "_6m-2";
export var switchDisabled = "_6m-8";
export var switchEnabled = "_6m-1";
export var textSwitchContainer = "_6m-9";
export var textSwitchOption = "_6m-a";
export var textSwitchOptionSelected = "_6m-b";
export var verticalContainer = "_6m-6";
export var xs = "_6m-4";